import { DEFAULT_COUNTRY_ISO2 } from '@/constants/location.constants';

export const emptyLocation = {
  title: '',
  timezone: 'America/New_York',
  addressId: '',
  addressLine: '',
  city: '',
  state: '',
  postalCode: '',
  country: DEFAULT_COUNTRY_ISO2,
  longitude: 0,
  latitude: 0,
};
